<template>
  <div class="swiper-container banner-swiper">
    <div class="swiper-wrapper">
      <a class="swiper-slide" v-for="(item,index) in banner" :key="index">
        <img :src="item.path" :alt="item.name" />
        <div class="banner-desc" v-if="baseBtn">
          <p class="banner-desc__tx1">{{ item.title }}</p>
          <p class="banner-desc__tx2">{{ item.subtitle }}</p>
          <button class="btn btn-orange" v-show="item.linkurl" @click="handleBtnClick(item.linkurl)">{{ $t('btns.now_check') }}</button>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getBanner } from "@/api";
export default {
  props: {
    loc: {
      type: String,
      default: '1'
    },
    baseBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      count: 5,
      banner:[]
    };
  },
  mounted() {
    getBanner({ count: this.count, loc: this.loc }).then(res=>{
        this.banner = res.banner;
        setTimeout(()=>{
            this.initSwiper();
        },20)
    });
  },
  methods: {
    initSwiper() {
      var mySwiper = new Swiper(".banner-swiper", {
        //   loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    handleBtnClick(linkurl) {
      this.linkToRouter(linkurl);
    }
  },
  components: {},
};
</script>

<style scoped lang='less'>
.banner-swiper {
  // height: 758px;
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  a{
      display: block;
  }
  .banner-desc {
    position: absolute;
    top: 40%;
    display: flex;
    flex-direction: column;
    // align-items: center;
    left: 14%;
    transform: translate(0%,-50%);
    .banner-desc__tx1 {
      font-size: 3rem;
      font-weight: 300;
      color: white;
      margin-bottom: .5rem;
      text-shadow: 0px 3px 6px rgba(0,0,0,.5);
    }
    .banner-desc__tx2 {
      font-size: 2.5rem;
      font-weight: 300;
      color: white;
      margin-bottom: .5rem;
      text-shadow: 0px 3px 6px rgba(0,0,0,.5);
    }
    .btn-orange {
      padding: 10px 20px;
      width: 120px;
    }
  }
}

@media (max-width: 992px) {
  .banner-swiper {
    // height: 479px;
    img {
      width: 100%;
      // height: 479px;
      display: block;
      position: relative;
      // left: 50%;
      // transform: translateX(-65%);
    }
    .banner-desc {
      .banner-desc__tx1 {
        font-size: 2rem;
      }
      .banner-desc__tx2 {
        font-size: 1.6rem;
      }
      .btn-orange {
       width: 105px; 
      }
    }
  }
}
</style>
